import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFootprintingPorkByPrimaryDataIdAdmin, deleteFootprintingProkByPrimaryDataId } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_CROP_PRIMARY_DATA, FOOTPRINTING_PORK_HERD_DETAILS, FOOTPRINTING_PORK_MANURE_ADDITIVE, FOOTPRINTING_PORK_MANURE_STORAGE } from "consts";

export const useDeleteFootprintingPorkByPrimaryDataId = (farmId: string, year: number, primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA],
    mutationFn: () => {
      if (!primaryDataId) return Promise.resolve(null);
      return isAdmin ? deleteFootprintingPorkByPrimaryDataIdAdmin(primaryDataId) : deleteFootprintingProkByPrimaryDataId(primaryDataId);
    },
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        // All the extra keys clean up the mess of stuff from this now-deleted data
        [FOOTPRINTING_PORK_HERD_DETAILS, primaryDataId, isAdmin],
        [FOOTPRINTING_PORK_MANURE_ADDITIVE, primaryDataId, isAdmin],
        [FOOTPRINTING_PORK_MANURE_STORAGE, primaryDataId, isAdmin],
        ...footprintingPorkPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
      ]);
    },
  });
};
